module.exports = __webpack_public_path__ + "img/zhu.a147ea0e.png";